// extracted by mini-css-extract-plugin
module.exports = {"loading_inline":"Spinner_loading_inline__3wl9e"};